import React from "react";
import { Link } from "react-router-dom";
import FoodSingleProduct from "./FoodCard";
import { Breadcrumbs } from "./../../Breadcrumb/index";

export default function FoodProduct() {
  return (
    <div className="productPage">
      <div class="container py-5">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <Breadcrumbs currentPathName="Food Products" />
              <div class="col-md-6">
                <ul class="list-inline shop-top-menu pb-3 pt-1">
                  <li class="list-inline-item">
                    <Link
                      class="h3 text-dark text-decoration-none mr-3 text-uppercase"
                      to="/foodProduct">
                      Food Products
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <FoodSingleProduct />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
